<template>
  <div id="divNomineeDeetails" style="font-size: small !important">
    <div class="Flex_Table tblEntryForm">
      <div
        class="Flex_Row"
        style="padding-left: 5px; padding-bottom: 5px"
        v-if="userTypeID == 1 && NomAuthID != -1"
      >
        <legend>
          <span
            class="radioSpan"
            :class="entryTypeID == '0' ? 'radioSpanChecked' : 'radioSpan'"
          >
            <input
              type="radio"
              v-model="entryTypeID"
              id="rblManual"
              name="entryTypeID"
              value="0"
            />
            <label for="rblManual"> Add Nominee(s) manual </label>
          </span>
          <span
            class="radioSpan"
            :class="entryTypeID == '1' ? 'radioSpanChecked' : 'radioSpan'"
          >
            <input
              type="radio"
              v-model="entryTypeID"
              id="rblExcel"
              name="entryTypeID"
              value="1"
            />
            <label for="rblExcel"> Import Nominee(s) using Excel </label>
          </span>
        </legend>
      </div>
      <fieldset class="EntryBlock" v-if="entryTypeID == 0">
        <legend>
          <div class="Flex_Table tblEntryForm" style="width: 100%">
            <div class="Flex_Row">
              <div class="Flex_Cell" style="width: 24%">
                <span v-if="userTypeID == 1 && PaymentStatus != 1"
                  >Master Account</span
                >
                <SearchDropDown
                  v-if="userTypeID == 1 && PaymentStatus != 1"
                  firstItem="-- Select --"
                  v-bind:list-data="masterAccount_List"
                  value-field="masterAccountID"
                  text-field="commonName"
                  v-model="masterAccountID"
                  style="width: 100%"
                  title="SELECT MEMBER TYPE"
                  v-on:change="ADDRECORD()"
                ></SearchDropDown>
              </div>
              <div class="Flex_Cell" valign="bottom" style="width: 26%">
                <input
                  type="button"
                  v-if="userTypeID == 1 && PaymentStatus != 1"
                  id="btnAdd"
                  name="btnAdd"
                  btnName="btnAdd"
                  value="Add"
                  @click="addEditMaster(1)"
                  style="padding: 5px 30px; margin-left: 10px"
                  title="Click here to Add as new"
                />
                <input
                  type="button"
                  id="btnEdit"
                  name="btnEdit"
                  btnName="btnEdit"
                  value="Edit"
                  @click="addEditMaster(2)"
                  style="padding: 5px 30px; margin-left: 10px"
                  title="Click here to update"
                  v-if="
                    masterAccountID != -1 &&
                    userTypeID == 1 &&
                    PaymentStatus != 1
                  "
                />
              </div>
              <div
                class="Flex_Cell"
                valign="bottom"
                align="right"
                style="width: 50%"
              >
                <div class="Flex_Table tblEntryForm">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      align="right"
                      valign="bottom"
                      style="width: 20%"
                    >
                      <AcceptInput
                        maxlength="6"
                        style="padding-left:0 padding-right:0; width:100px"
                        ref="captcha"
                        type="textbox"
                        v-model="captchaValue1"
                        :isRequired="true"
                        placeholder="CAPTCHA"
                        class="CreateAccount"
                        regExp="([0-9])*"
                      />&nbsp;&nbsp;
                      <img
                        id="imgCaptcha1"
                        style="border: 1px solid #000"
                      />&nbsp;&nbsp;
                      <img
                        src="../assets/images/refresh.png"
                        @click="generateCaptcha1(2, 110, 21)"
                        style="
                          cursor: pointer;
                          height: 20px;
                          border: 1px solid #000;
                          border-radius: 50%;
                        "
                        title="Click here to refresh captcha"
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      align="right"
                      valign="bottom"
                      style="width: 80%"
                    >
                      <input
                        type="button"
                        id="btnSave"
                        name="btnSave"
                        btnName="btnSave"
                        :value="btnSave"
                        style="padding: 5px 15px 5px 15px"
                        :title="btnSaveMsg"
                        @click="SaveNominee()"
                      />
                      <input
                        type="button"
                        id="btnCancel"
                        name="btnCancel"
                        btnName="btnCancel"
                        :value="btnCancel"
                        style="padding: 5px 15px 5px 15px"
                        :title="btnCancelMsg"
                        @click="clear(1)"
                      />
                      <div class="Flex_Row">
                        <input
                          type="button"
                          id="btnPay"
                          name="btnPay"
                          btnName="btnPay"
                          value="Proceed to Pay"
                          style="padding: 5px 15px 5px 15px"
                          title="Click here to Payment Option"
                          @click="showMessageBoxPaymentOption()"
                          v-if="
                            NomAuthID != -1 &&
                            (userTypeID == 1 || userTypeID == 2) &&
                            (PaymentStatus == 0 || PaymentStatus == 2)
                          "
                        />
                      </div>
                      <div class="Flex_Row">
                        <input
                          type="button"
                          id="btnRetryPay"
                          name="btnRetryPay"
                          btnName="btnRetryPay"
                          value="Update Payment Status"
                          style="
                            padding: 5px 15px 5px 15px;
                            background-color: red;
                          "
                          title="If Your payment has been deducted but payment reciept has not been generated than Click here to Update Payment Status..! "
                          @click="RetryPayment(NomAuthID)"
                          v-if="
                            (userTypeID == 1 || userTypeID == 2) &&
                            PaymentMode == 1 &&
                            PaymentStatus == 0
                          "
                        />
                      </div>
                      <input
                        type="button"
                        v-if="userTypeID == 2 && PaymentStatus == 1"
                        style="
                          padding: 5px 20px;
                          margin-left: 10px;
                          background-color: #f7b408 !important;
                          color: black !important;
                        "
                        id="btnPaid"
                        name="btnPaid"
                        btnName="btnPaid"
                        value="Paid"
                        @click="paidOption()"
                      />
                    </div>
                  </div>
                </div>
                <!-- v-if="candidateID != -1" -->
                <!-- <input
                  type="button"
                  id="btnNo"
                  name="Save"
                  btnName="btnNo"
                  value="Save"
                  style="padding: 5px 15px 5px 15px"
                  title="Click Here to Save"
                  @click="SaveNominee()"
                  v-if="userTypeID != 1"
                />
                <input
                  type="button"
                  id="btnNo"
                  name="Save"
                  btnName="btnNo"
                  value="Save"
                  style="padding: 5px 15px 5px 15px"
                  title="Click Here to Save"
                  @click="showMessageBox3()"
                  v-if="userTypeID == 1 && NomAuthID != -1"
                />
                <input
                  type="button"
                  id="btnSaveinMasters"
                  name="Save in Master"
                  btnName="btnSaveInMaster"
                  value="Save in Master"
                  style="padding: 5px 15px 5px 15px"
                  title="Click Here to Save"
                  @click="showMessageBox4()"
                  v-if="userTypeID == 1"
                />
                <input
                  type="button"
                  id="btnNo"
                  name="Reset"
                  btnName="btnNo"
                  value="Reset"
                  style="padding: 5px 15px 5px 15px"
                  title="Click Here to Save"
                  @click="RESETNOMINEE()"
                /> -->
              </div>
              <!--  <div
            class="Flex_Cell"
            v-if="userTypeID == 11 && checkBoxDisplay == true"
            style="width: 25%"
          >
            <input
              valign="middle"
              type="button"
              style="padding: 3px 10px 3px 10px; margin-top: -1px"
              text="ADD"
              value="ADD"
              @click="ADDRECORD()"
            />
            <input
              valign="middle"
              type="button"
              style="padding: 3px 10px 3px 10px; margin-top: -1px"
              text="EDIT"
              value="EDIT"
              @click="EDITRECORD()"
            />
          </div>-->
            </div>
          </div>
        </legend>
        <div class="Flex_Table tblEntryForm">
          <div class="Flex_Row RowHeight" style="display: none">
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="GST No."
                description="ENTER GST NO."
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="GST No."
                  v-model="gstNO"
                  maxlength="20"
                  regExp="([a-zA-Z/0-9])*"
                  title="ENTER GST NO."
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="PF No."
                description="ENTER PF NO."
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="PF No."
                  v-model="pFNo"
                  maxlength="20"
                  regExp="([a-zA-Z/0-9])*"
                  title="ENTER PF NO."
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%" v-if="userTypeID == 2">
              <BlockInput
                label="Member Type"
                description="ENTER MEMBER TYPE"
                :isRequired="false"
              >
                <SearchDropDown
                  v-bind:list-data="memberType_list"
                  value-field="memberTypeID"
                  text-field="memberTypeName"
                  v-model="memberTypeID"
                  style="width: 100%"
                  title="SELECT MEMBER TYPE"
                ></SearchDropDown>
              </BlockInput>
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Nominee Ref No."
                description="ENTER NOMINEE REFERENCE NO."
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Nominee Ref No."
                  v-model="refNo"
                  maxlength="256"
                  disabled
                  regExp="([a-zA-Z/0-9\-])*"
                  title="ENTER NOMINEE REFERENCE NO."
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Country"
                description="SELECT COUNTRY"
                :isRequired="true"
              >
                <SearchDropDown
                  v-bind:list-data="country_lst"
                  firstItem="---Select Country ---"
                  value-field="countryID"
                  text-field="countryName"
                  v-model="countryID"
                  style="width: 100%"
                  title="SELECT COUNTRY"
                ></SearchDropDown>
              </BlockInput>
            </div>
            <div valign="middle" class="Flex_Cell" style="width: 25%">
              <span class="spanRadion" title="Select Attendence Type">
                Attendance Type:
                <input
                  type="radio"
                  v-model="attTypeID"
                  id="rblOffline"
                  name="attType"
                  :disabled="ModeOfExecution != 3"
                  value="0"
                />
                <label for="rblOffline">In Campus</label>
                <input
                  type="radio"
                  v-model="attTypeID"
                  id="rblOnline"
                  name="attType"
                  value="1"
                  :disabled="ModeOfExecution != 3"
                />
                <label for="rblOnline">Online</label>
              </span>
            </div>
            <div class="Flex_Cell" style="width: 25%" v-if="userTypeID == 2">
              <BlockInput
                label="Member Type"
                description="Member Type"
                :isRequired="false"
              >
                <SearchDropDown
                  v-bind:list-data="memberType_list"
                  value-field="memberTypeID"
                  text-field="memberTypeName"
                  v-model="memberTypeID"
                  style="width: 100%"
                  title="SELECT MEMBER TYPE"
                  :disabled="ModeOfExecution != 3"
                ></SearchDropDown>
              </BlockInput>
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 7%">
              <BlockInput
                label="Title"
                description="SELECT TITLE"
                :isRequired="false"
              >
                <SearchDropDown
                  v-bind:list-data="TitleList"
                  value-field="titleID"
                  text-field="titleName"
                  v-model="titleID"
                  style="width: 100%"
                  title="SELECT TITLE"
                ></SearchDropDown>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 18%">
              <BlockInput
                label="First Name"
                description="ENTER FIRST NAME"
                :isRequired="true"
              >
                <AcceptInput
                  :isRequired="true"
                  placeholder="First Name"
                  v-model.trim="fName"
                  maxlength="256"
                  regExp="([a-zA-Z])*"
                  title="ENTER FIRST NAME"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Middle Name"
                description="ENTER MIDDLE NAME"
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Middle Name"
                  v-model="mName"
                  maxlength="256"
                  regExp="([a-zA-Z])*"
                  title="ENTER MIDDLE NAME"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Last Name"
                description="ENTER LAST NAME"
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Last Name"
                  v-model="lName"
                  maxlength="256"
                  regExp="([a-zA-Z])*"
                  title="ENTER LAST NAME"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Email-ID"
                description="ENTER EMAIL"
                :isRequired="true"
              >
                <AcceptInput
                  :isRequired="true"
                  placeholder="Email-ID"
                  v-model.trim="email1"
                  maxlength="200"
                  :disabled="isDisableEmail"
                  regExp="([a-zA-Z0-9\@\.\_\-])*"
                  title="ENTER EMAIL"
                  type="text"
                />
                <!-- :disabled="userTypeID == 3 && email1 != ''" -->
              </BlockInput>
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Mobile No. [C.C./Mobile No.]"
                description="ENTER MOBILE NO."
                :isRequired="true"
              >
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="C.C."
                        v-model.trim="mobileCC"
                        maxlength="5"
                        :disabled="isDisableMobile"
                        regExp="([+0-9])*"
                        title="ENTER C.C."
                      />
                      <!-- :disabled="
                          userTypeID == 3 && mobileCC != '' && mobileNo != ''
                        " -->
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 80% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="Mobile No."
                        v-model="mobileNo"
                        :maxlength="mobileCC == '+91' ? '10' : '20'"
                        :disabled="isDisableMobile"
                        regExp="([0-9])*"
                        title="ENTER MOBILE NO."
                      />
                      <!-- :disabled="
                          userTypeID == 3 && mobileCC != '' && mobileNo != ''
                        " -->
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="WhatsApp No. [C.C./WhatsApp No.]"
                description="ENTER WHATSAPP NO."
                :isRequired="false"
              >
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="C.C."
                        v-model="altMobileCC"
                        maxlength="3"
                        regExp="([+0-9])*"
                        title="ENTER C.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 80% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="WhatsApp No."
                        v-model="altMobileNo"
                        maxlength="10"
                        regExp="([0-9])*"
                        title="ENTER WHATSAPP NO."
                      />
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Nomination Date"
                description="PLEASE PICK NOMINATION DATE"
                :isRequired="true"
              >
                <DateControl
                  v-model="nominationDate"
                  :showDate="true"
                  disabled
                  style="width: 220px"
                  title="PLEASE PICK NOMINATION DATE"
                ></DateControl>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Date of Acceptance"
                description="PLEASE PICK DATE OF ACCEPTANCE"
                :isRequired="false"
              >
                <DateControl
                  v-model="dateOfAcceptance"
                  :showDate="true"
                  disabled
                  style="width: 220px"
                  title="PLEASE PICK DATE OF ACCEPTANCE"
                ></DateControl>
              </BlockInput>
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div
              class="Flex_Cell"
              valign="middle"
              style="width: 25%; display: none"
            >
              <label for="rblPickup">Is Pickup Required :</label>
              <input
                v-model="isPickUpRequired"
                type="radio"
                id="rblisPickup"
                value="1"
              />
              <label for="rblisPickup">Yes</label>
              <input
                v-model="isPickUpRequired"
                type="radio"
                id="rblisPickup2"
                value="0"
              />
              <label for="rblisPickup2">No</label>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="spanRadion" title="Select Gender"
                >Gender :
                <input
                  v-model="genderID"
                  type="radio"
                  id="rblgender1"
                  value="1"
                />
                <label for="rblgender1"> Male</label>
                <input
                  v-model="genderID"
                  type="radio"
                  id="rblgender2"
                  value="2"
                />
                <label for="rblgender2">Female</label>
              </span>
            </div>
            <div class="Flex_Cell" valign="middle" style="width: 25%">
              <span class="spanRadion" title="Is Cancel">
                Is Cancel :
                <input
                  v-model="isCancel"
                  type="radio"
                  id="rblisCancel1"
                  :disabled="userTypeID == 3 || PaymentStatus == 1"
                  value="1"
                />
                <label for="rblisCancel1"> Yes</label>
                <input
                  v-model="isCancel"
                  type="radio"
                  id="rblisCancel2"
                  :disabled="userTypeID == 3 || PaymentStatus == 1"
                  value="0"
                />
                <label for="rblisCancel2">No</label>
              </span>
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%; display: none">
              <BlockInput
                label="Contact No. [C.C./A.C./Contact No.]"
                description="ENTER CONTACT NO."
                :isRequired="false"
              >
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="C.C."
                        v-model="contactCC"
                        maxlength="3"
                        regExp="([+0-9])*"
                        title="ENTER C.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="A.C."
                        v-model="contactAC"
                        maxlength="3"
                        regExp="([0-9])*"
                        title="ENTER A.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 60% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="Contact No."
                        v-model="contactNo"
                        maxlength="10"
                        regExp="([0-9])*"
                        title="ENTER CONTACT NO."
                      />
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%; display: none">
              <BlockInput
                label="Alternate Contact No. [C.C./A.C./Contact No.]"
                description="ENTER ALTERNATE CONTACT NO."
                :isRequired="false"
              >
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="C.C."
                        v-model="altContactCC"
                        maxlength="3"
                        regExp="([+0-9])*"
                        title="ENTER C.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="A.C."
                        v-model="altContactAC"
                        maxlength="3"
                        regExp="([0-9])*"
                        title="ENTER A.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 60% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="Alternate Contact No."
                        v-model="altContactNo"
                        maxlength="10"
                        regExp="([0-9])*"
                        title="ENTER ALTERNATE CONTACT NO."
                      />
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%; display: none">
              <BlockInput
                label="FAX No. [C.C./A.C./FAX No.]"
                description="ENTER FAX NO."
                :isRequired="false"
              >
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="C.C."
                        v-model="faxCC"
                        maxlength="3"
                        regExp="([+0-9])*"
                        title="ENTER C.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="A.C."
                        v-model="faxAC"
                        maxlength="3"
                        regExp="([0-9])*"
                        title="ENTER A.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 60% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="FAX No."
                        v-model="faxNo"
                        maxlength="10"
                        regExp="([0-9])*"
                        title="ENTER FAX NO."
                      />
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                style="display: none"
                label="Bank Name"
                description="ENTER BANK NAME"
                :isRequired="true"
              >
                <SearchDropDown
                  v-bind:list-data="bank_lists"
                  value-field="bankID"
                  text-field="bankName"
                  v-model="bankID"
                  first-item="--Select--"
                  style="width: 100%"
                  title="SELECT BANK NAME"
                ></SearchDropDown>
              </BlockInput>
              <BlockInput
                label="Orgnization Name"
                description="ENTER ORGNIZATION NAME"
                :isRequired="userTypeID == 2 ? true : false"
              >
                <AcceptInput
                  :isRequired="userTypeID == 2 ? true : false"
                  placeholder="Enter Orgnization Name"
                  v-model="organizationName"
                  maxlength="256"
                  regExp="([a-zA-Z0-9\-\ \_])*"
                  title="ENTER ORGNIZATION"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <!--    <BlockInput
              label="Designation"
              description="ENTER DESIGNATION"
              :isRequired="true"
            >
              <AcceptInput
                :isRequired="true"
                placeholder="Designation"
                v-model="desigName"
                maxlength="256"
                regExp="([a-zA-Z])*"
                title="ENTER DESIGNATION"
              />
            </BlockInput>-->
              <span class="mandatorySpan" :class="{ Required: true }">
                Designation
              </span>
              <DesignationMasterList
                v-if="userTypeID != -1"
                v-model="desigID"
                id="serDesignation"
                title="SELECT DESIGNATION"
                @reset="desigID = -1"
                :Required="true"
              ></DesignationMasterList>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Employee No."
                description="ENTER EMPLOYEE NO."
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Employee No."
                  v-model.trim="empNo"
                  maxlength="256"
                  title="ENTER EMPLOYEE NO."
                  regExp="([a-zA-Z0-9\|\-\/\_])*"
                />
              </BlockInput>
            </div>

            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Email-ID (SEC)"
                description="ENTER EMAIL (SEC)"
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Email-ID"
                  v-model.trim="email2"
                  maxlength="200"
                  regExp="([a-zA-Z0-9\@\.\_\-])*"
                  title="ENTER EMAIL"
                  type="text"
                />
              </BlockInput>
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Date of Birth"
                description="PLEASE PICK DATE OF BIRTH"
                :isRequired="false"
              >
                <DateControl
                  v-model="dob"
                  :showDate="true"
                  style="width: 220px"
                  title="PLEASE PICK DATE OF BIRTH"
                ></DateControl>
              </BlockInput>
            </div>

            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Scale"
                description="ENTER SCALE"
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Scale"
                  v-model="scale"
                  maxlength="200"
                  regExp="([a-zA-Z0-9\_\-])*"
                  title="ENTER SCALE"
                />
              </BlockInput>
            </div>

            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Date of Arrival/Time"
                description="ENTER DATE OF ARRIVAL/TIME"
                :isRequired="false"
              >
                <div class="Flex_Table tblEntryForm">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 75% !important; padding-left: 0px"
                    >
                      <DateControl
                        v-model="arrivalDate"
                        :showDate="true"
                        style="width: 220px"
                        title="ENTER PLEASE PICK OF ARRIVAL"
                      ></DateControl>
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 25% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <Time v-model="arrivalTime"></Time>
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Arrival Travel Mode"
                description="PLEASE PICK DATE OF ARRIVAL"
                :isRequired="false"
              >
                <SearchDropDown
                  v-bind:list-data="travelMode_List"
                  value-field="travelModeID"
                  text-field="travelModeValue"
                  v-model="arrivalModeID"
                  first-item="--Select--"
                  style="width: 98%"
                  title="SELECT TRAVEL MODE"
                ></SearchDropDown>
              </BlockInput>
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Arrival Details"
                description="PLEASE PICK DATE OF ARRIVAL"
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Arrival Details"
                  v-model="arrivalDetails"
                  maxlength="200"
                  regExp="([a-zA-Z0-9\_\-])*"
                  title="ENTER Arrival Details"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Date of Departure/ Time"
                description="ENTER DATE OF DEPARTURE/ TIME"
                :isRequired="false"
              >
                <div class="Flex_Table tblEntryForm">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 75% !important; padding-left: 0px"
                    >
                      <DateControl
                        v-model="departureDate"
                        :showDate="true"
                        style="width: 220px"
                        title="ENTER PLEASE PICK OF DEPARTURE"
                      ></DateControl>
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 25% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <Time v-model="departureTime"></Time>
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Departure Travel Mode"
                description="PLEASE PICK MODE OF DEPARTURE"
                :isRequired="false"
              >
                <SearchDropDown
                  v-bind:list-data="travelMode_List"
                  value-field="travelModeID"
                  text-field="travelModeValue"
                  v-model="departureModeID"
                  first-item="--Select--"
                  style="width: 98%"
                  title="SELECT TRAVEL MODE"
                ></SearchDropDown>
              </BlockInput>
            </div>

            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Departure Details"
                description="PLEASE PICK DATE OF DEPARTURE"
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Departure Details"
                  v-model="departureDetails"
                  maxlength="200"
                  regExp="([a-zA-Z0-9\_\-])*"
                  title="ENTER DEPARTURE DETAILS"
                />
              </BlockInput>
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: true }">
                Address(Current)
              </span>
              <textarea
                type="textarea"
                v-model.trim="curAddress"
                style="height: 50px; width: 99%"
              />
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: false }">
                Address(Permanent)</span
              >
              <textarea
                type="text"
                v-model="perAddress"
                style="height: 50px; width: 99%"
              />
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: false }"
                >Remark</span
              >
              <textarea
                type="textarea"
                v-model="remarkData"
                style="height: 50px; width: 99%"
              />
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: false }">
                Food Preference
              </span>
              <select
                :isRequired="true"
                id="ddlFoodPreference"
                v-model="FoodPrefID"
              >
                <option value="-1">-- None --</option>
                <option
                  v-for="(fp, index) in foodPreferencelst"
                  :key="index"
                  :value="fp.foodPreference"
                >
                  {{ fp.foodPreference }}
                </option>
              </select>
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%">
              <div class="Flex_Table tblEntryForm">
                <div class="Flex_Row">
                  <div
                    style="display: none"
                    class="Flex_Cell_Left"
                    v-if="userTypeID == 1 && checkBoxDisplay == true"
                    valign="middle"
                  >
                    <label for="chksaveInMasterAlso"
                      >Check for Save in Master</label
                    >
                    <input
                      type="checkbox"
                      v-model="saveInMasterAlso"
                      id="chksaveInMasterAlso"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <div class="Flex_Table tblEntryForm">
                <div class="Flex_Row">
                  <div class="Flex_Cell_Left" v-if="userTypeID == 1"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="EntryBlock" v-if="entryTypeID == 1">
        <legend>Import Nominee(s)</legend>
        <div
          class="Flex_Table tblEntryForm"
          align="center"
          v-if="ExcelData.length == 0"
        >
          <div class="Flex_Row" style="width: 70%">
            <div class="Flex_Cell GridFlex">
              <fieldset style="min-height: 100px">
                <legend>
                  <div class="Flex_Table tblEntryForm" style="width: 100%">
                    <div class="Flex_Row" valign="middle">
                      <div class="Flex_Cell" align="left">
                        PLEASE READ BEFORE IMPORT DATA FROM EXCEL.
                      </div>
                      <div class="Flex_Cell" align="right">
                        <input
                          type="button"
                          id="btnExport"
                          name="btnExport"
                          btnName="btnExport"
                          value="DOWNLOAD SAMPLE"
                          style="padding: 5px 15px 5px 15px"
                          title="Click Here to download sample"
                          @click="downloadSample()"
                        />
                        <!-- <JsonExcel
                          name="Import_Programme_Office_Participants.xls"
                          :data="json_data"
                          :footer="footData"
                        >
                          <input
                            type="button"
                            id="btnExport"
                            name="btnExport"
                            btnName="btnExport"
                            value="DOWNLOAD SAMPLE"
                            style="padding: 5px 15px 5px 15px"
                            title="Click Here to download sample"
                          />
                        </JsonExcel> -->
                      </div>
                    </div>
                  </div>
                </legend>
                <ul
                  style="text-align: left; margin-top: 5px; margin-left: 15px"
                >
                  <li class="payinstruction">
                    Please ensure the format for excel same as the given sample
                    file.
                  </li>
                  <li class="payinstruction">
                    Please ensure the columns which are in red color are
                    mandatory to be filled.
                  </li>
                  <li class="payinstruction">
                    Some fields like Title, Nationality, Gender, Designation,
                    Arrival Mode & departure mode should be correct.
                  </li>
                  <li class="payinstruction">
                    Please check the date format like "dd mmm yyyy" (ie. 01 Jan
                    1989) & time format like "hh mm AM/PM" (ie. 10 30 AM)
                  </li>
                  <li class="payinstruction">
                    Don't enter any garbage/spacial character data.
                  </li>
                  <li class="payinstruction">
                    Before upload, Please save Excel "Save as xls or xlsx". (if
                    not)
                  </li>
                </ul>
              </fieldset>
            </div>
          </div>
          <div class="Flex_Row" align="center">
            <div class="Flex_Cell">
              <input type="checkbox" v-model="isUpload" id="chkUpload" />
              <label for="chkUpload">Click for upload EXCEL</label>
            </div>
          </div>
          <div class="Flex_Row" align="center" v-if="isUpload">
            <div class="Flex_Cell">
              <input
                type="file"
                style="width: 25% !important"
                ref="fileXls"
                @change="GetExcelData"
              />
            </div>
          </div>
        </div>
        <div
          class="Flex_Row"
          v-if="
            entryTypeID == 1 &&
            ExcelData.length > 0 &&
            ExcelData[0].candidateID != -1
          "
        >
          <div class="Flex_Cell" style="width: 70%">
            <input
              type="button"
              id="btnUpdate"
              name="btnUpdate"
              value="Import updated Excel data"
              style="padding: 5px 30px; margin-left: 10px"
              title="Click here to Upload updated records."
              @click="updateNomineeData()"
            />
            <input
              type="button"
              id="btnClear"
              name="btnClear"
              value="Go Back to Upload excel again."
              style="padding: 5px 30px; margin-left: 10px"
              title="Click here to Add as new"
              @click="clearImportExcel()"
            />
          </div>
          <div class="Flex_Table">
            <div class="Flex_Row">
              <div class="Flex_Cell" style="width: 70%">
                <fieldset
                  class="EntryBlock"
                  style="
                    height: calc(100vh - 300px);
                    overflow: auto;
                    padding-top: 10px;
                  "
                >
                  <div
                    class="Flex_Table ekkGrid"
                    style="width: 100%; overflow-wrap: anywhere"
                    v-if="
                      ExcelData.length > 0 && ExcelData[0].candidateID != -1
                    "
                  >
                    <div class="Flex_Row">
                      <div class="Flex_Cell">
                        <b>
                          <span
                            style="color: green; font-size: 16px"
                            v-if="ExcelData[0].isSuccess == 1"
                          >
                            {{ ExcelData.length }} Records imported successfully
                          </span>
                          <span v-else style="color: red; font-size: 16px">
                            Records not imported.
                          </span>
                        </b>
                      </div>
                    </div>
                    <div class="Flex_Row GridHeader">
                      <div class="Flex_Cell" style="width: 6%">Edit</div>
                      <div class="Flex_Cell" style="width: 8%">Sr. No.</div>
                      <div class="Flex_Cell" style="width: 18%">Name</div>
                      <div class="Flex_Cell" style="width: 16%">
                        Current Mobile
                      </div>
                      <div class="Flex_Cell" style="width: 20%">Email</div>
                      <div class="Flex_Cell" style="width: 12%">
                        Update status
                      </div>
                      <div class="Flex_Cell" style="width: 20%">Status</div>
                    </div>
                    <div
                      class="Flex_Row"
                      style="font-size: 12px; overflow-wrap: anywhere"
                      valign="middle"
                      v-for="(row, index) in ExcelData"
                      :key="index"
                      :style="row.isError == 1 ? 'background-color:pink' : ''"
                    >
                      <div class="Flex_Cell" align="center" style="width: 6%">
                        <b
                          ><span
                            v-if="row.isError == 1"
                            class="glyphicons edit"
                            @click="editNomineeDetails(row, index)"
                          ></span
                        ></b>
                      </div>
                      <div class="Flex_Cell" style="width: 8%">
                        <b> {{ index + 1 }}. </b>
                      </div>
                      <div class="Flex_Cell" style="width: 18%">
                        {{ row.title }} {{ row.firstName }} {{ row.middleName }}
                        {{ row.surName }}
                      </div>
                      <div class="Flex_Cell" style="width: 16%">
                        {{ row.curMobileCC }} - {{ row.curMobile }}
                      </div>
                      <div class="Flex_Cell" style="width: 20%">
                        {{ row.email }}
                      </div>
                      <div class="Flex_Cell" style="width: 12%">
                        <b>
                          <span
                            v-if="row.isError == 1 && row.updateStatusID == 1"
                            style="color: green"
                          >
                            {{ row.updateStatus }}
                          </span>
                          <span
                            v-if="row.isError == 1 && row.updateStatusID != 1"
                            style="color: red"
                          >
                            Need to be updated
                          </span>
                        </b>
                      </div>
                      <div class="Flex_Cell" style="width: 20%">
                        <b>
                          <span v-if="row.isError == 0" style="color: green">
                            {{ row.errorMessage }}
                          </span>
                          <span v-else style="color: red">
                            {{ row.errorMessage }}
                          </span>
                        </b>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div class="Flex_Cell" style="width: 30%">
                <fieldset
                  class="EntryBlock"
                  style="
                    height: calc(100vh - 300px);
                    overflow: auto;
                    padding-top: 10px;
                  "
                >
                  <div class="Flex_Table tblEntryForm">
                    <div class="Flex_Row RowHeight" v-if="isTitleEdit">
                      <div class="Flex_Cell">
                        <BlockInput
                          label="Title"
                          description="ENTER TITLE"
                          :isRequired="true"
                        >
                          <SearchDropDown
                            v-bind:list-data="TitleList"
                            value-field="titleID"
                            text-field="titleName"
                            v-model="titleID"
                            :isRequired="true"
                            style="width: 100%"
                            title="SELECT TITLE"
                          ></SearchDropDown>
                        </BlockInput>
                      </div>
                    </div>
                    <div class="Flex_Row RowHeight" v-if="isNationalityEdit">
                      <div class="Flex_Cell">
                        <BlockInput
                          label="Nationality"
                          description="ENTER NATIONALITY"
                          :isRequired="false"
                        >
                          <SearchDropDown
                            v-bind:list-data="country_lst"
                            firstItem="---Select Nationality ---"
                            value-field="countryID"
                            text-field="countryName"
                            v-model="countryID"
                            :isRequired="false"
                            title="SELECT NATIONALITY"
                          ></SearchDropDown>
                        </BlockInput>
                      </div>
                    </div>
                    <div class="Flex_Row RowHeight" v-if="isGenderEdit">
                      <div class="Flex_Cell">
                        <span class="spanRadion" title="Select Gender"
                          >Gender :
                          <input
                            v-model="genderID"
                            type="radio"
                            id="rblgender1"
                            value="1"
                          />
                          <label for="rblgender1">Male</label>
                          <input
                            v-model="genderID"
                            type="radio"
                            id="rblgender2"
                            value="2"
                          />
                          <label for="rblgender2">Female</label>
                        </span>
                      </div>
                    </div>
                    <div class="Flex_Row RowHeight" v-if="isDesigEdit">
                      <div class="Flex_Cell">
                        <BlockInput
                          label="Designation"
                          description="ENTER DESIGNATION"
                          :isRequired="true"
                        >
                          <SearchDropDown
                            v-bind:list-data="desig_List"
                            :isRequired="true"
                            value-field="desigID"
                            text-field="desigName"
                            v-model="desigID"
                            first-item="--Select--"
                            title="SELECT DESIGNATION"
                          ></SearchDropDown>
                        </BlockInput>
                      </div>
                    </div>
                    <div class="Flex_Row RowHeight" v-if="isArrModeEdit">
                      <div class="Flex_Cell">
                        <BlockInput
                          label="Arrival Travel Mode"
                          description="ENTER ARRIVAL TRAVEL MODE"
                          :isRequired="false"
                        >
                          <SearchDropDown
                            v-bind:list-data="travelMode_List"
                            value-field="travelModeID"
                            :isRequired="false"
                            text-field="travelModeValue"
                            v-model="arrivalModeID"
                            first-item="--Select--"
                            title="SELECT TRAVEL MODE"
                          ></SearchDropDown>
                        </BlockInput>
                      </div>
                    </div>
                    <div class="Flex_Row RowHeight" v-if="isDepModeEdit">
                      <div class="Flex_Cell">
                        <BlockInput
                          label="Departure Travel Mode"
                          description="ENTER DEPARTURE TRAVEL MODE"
                          :isRequired="false"
                        >
                          <SearchDropDown
                            v-bind:list-data="travelMode_List"
                            value-field="travelModeID"
                            :isRequired="false"
                            text-field="travelModeValue"
                            v-model="departureModeID"
                            first-item="--Select--"
                            title="SELECT DEPARTURE TRAVEL MODE"
                          ></SearchDropDown>
                        </BlockInput>
                      </div>
                    </div>
                  </div>
                  <div class="Flex_Row">
                    <div class="Flex_Cell" v-if="isEdit">
                      <input
                        type="button"
                        id="btnUpdate"
                        name="btnUpdate"
                        value="Updated Record"
                        style="padding: 5px 30px; margin-left: 10px"
                        title="Click here to update records."
                        @click="updateExcel()"
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import AcceptInput from "./ekkControls/AcceptInput";
import AcceptTextArea from "./ekkControls/AcceptTextArea";
import SearchDropDown from "./ekkControls/SearchDropDown";
import CheckDropDown from "./ekkControls/CheckDropDown";
import Tab from "./ekkControls/Tab";
import BlockInput from "./ekkControls/BlockInput";
import DateControl from "./ekkControls/DateControl";
import OnOff from "./ekkControls/OnOff";
import allMasterJS from "./serviceJS/AllMasterJS.js";
import nomineeDetailsJS from "./serviceJS/NomineeDetails.js";
import LoginJS from "./serviceJS/loginjs.js";
import Time from "./ekkControls/Time";
import DesignationMasterList from "./usercontrols/DesignationMasterList.vue";
import JsonExcel from "vue-json-excel";
import XLSX from "../../node_modules/xlsx/dist/xlsx.full.min.js";
import Designation1MasterList from "./usercontrols/Designation1MasterList.vue";
import PaymentJS from "./serviceJS/paymentJS.js";
// Import AcceptInput libraries from "./ekkControls/AcceptInput" for using the Custom made vue for AcceptInput for (restriction of inputing)
export default {
  name: "NomineeDetails",
  components: {
    DateControl: DateControl,
    AcceptInput: AcceptInput,
    AcceptTextArea: AcceptTextArea,
    SearchDropDown: SearchDropDown,
    CheckDropDown: CheckDropDown,
    Tab: Tab,
    BlockInput: BlockInput,
    OnOff: OnOff,
    Time: Time,
    DesignationMasterList: DesignationMasterList,
    Designation1MasterList: Designation1MasterList,
    JsonExcel: JsonExcel,
    XLSX: XLSX,
  },
  props: {
    NomAuthID: { required: true },
    userTypeID: { required: true },
    TitleList: { required: true },
    ProgID: { required: true },
    NominationCode: { required: true },
    CandidateData: { required: true },
    ModeOfExecution: { required: true },
    PaymentStatus: { required: true },
    PaymentMode: { required: true },
  },
  data() {
    return {
      entryTypeID: 0,
      areaID: -1,
      candGRNo: "",
      refNo: "",
      gstNO: "",
      pFNo: "",
      attTypeID: -1,
      titleID: 1,
      fName: "",
      mName: "",
      lName: "",
      country_lst: [],
      countryID: -1,
      countryName: "",
      contactCC: "+91",
      contactAC: "",
      contactNo: "",
      altContactCC: "+91",
      altContactAC: "",
      altContactNo: "",
      mobileCC: "+91",
      mobileNo: "",
      isDisableMobile: false,
      altMobileCC: "+91",
      altMobileNo: "",
      faxCC: "+91",
      faxAC: "",
      faxNo: "",
      bankID: -1,
      bank_lists: [],
      bankName: "",
      desigID: -1,
      desigName: "",
      empNo: "",
      email1: "",
      isDisableEmail: false,
      email2: "",
      dob: new Date(),
      scale: "",
      nominationDate: new Date(),
      nominationCode: "",
      roomID: -1,
      dateOfAcceptance: new Date(),
      arrivalDate: new Date(),
      arrivalTime: new Date(),
      arrivalMode_list: [],
      arrivalModeID: -1,
      arrivalDetails: "",
      departureDate: new Date(),
      departureTime: new Date(),
      departureMode_list: [],
      departureModeID: -1,
      departureDetails: "",
      isPickUpRequired: 0,
      genderID: 1,
      isCancel: 0,
      curAddress: "",
      perAddress: "",
      remarkData: "",
      memberType_list: [],
      memberTypeID: -1,
      memberBank_list: [],
      memberBankID: -1,
      nominee_list: [],
      nomineeID: -1,
      title_List: [],
      email: "",
      candData: [],
      desigText: "",
      travelMode_List: [
        {
          travelModeID: 1,
          travelModeValue: "Air",
        },
        {
          travelModeID: 2,
          travelModeValue: "Rail",
        },
        {
          travelModeID: 3,
          travelModeValue: "Road",
        },
      ],
      travelModeID: -1,
      candidateID: -1,
      isIndividualNominee: -1,
      isOnlineCandidate: -1,
      isApproved: -1,
      isSyncedInERP: -1,
      entryDate: new Date(),
      organizationName: "",
      candidateMasterAccountID: -1,
      saveInMasterAlso: false,
      paymentMode: -1,
      candidateLoginID: -1,
      userLoginID: -1,
      lst_CandidateNominate: [],
      lst_CandidateTemplate: [],
      masterAccount_List: [],
      masterAccountID: -1,
      checkBoxDisplay: true,
      buttonDisplay: true,
      isForEdit: 0,
      isSaveinMasterAsNew: false,
      //============================================================
      btnSave: "Save",
      btnSaveMsg: "Click Here to Save",
      btnCancel: "Clear",
      btnCancelMsg: "Click Here to Clear",
      captchaValue1: "",
      captchaKey1: "",
      desigName: "",
      isUpload: false,
      ExcelData: [],
      ExcelHeaderData: [],
      CountStr: "",
      desig_List: [],
      desig: -1,
      isTitleEdit: false,
      isDesigEdit: false,
      isNationalityEdit: false,
      isGenderEdit: false,
      isArrModeEdit: false,
      isDepModeEdit: false,
      isEdit: false,
      editRow: [],
      editindex: -1,
      UpdateExcelData: [],
      foodPreferencelst: [],
      FoodPrefID: "-1",
    };
  },
  methods: {
    editNomineeDetails(row, index) {
      this.titleID = 1;
      this.desigID = -1;
      this.countryID = -1;
      this.genderID = -1;
      this.arrivalModeID = -1;
      this.departureModeID = -1;
      this.editindex = index;
      this.editRow = row;
      this.isTitleEdit = false;
      this.isDesigEdit = false;
      this.isNationalityEdit = false;
      this.isGenderEdit = false;
      this.isArrModeEdit = false;
      this.isDepModeEdit = false;
      this.isEdit = false;
      if (row.titleID == -1) {
        this.isTitleEdit = true;
        this.isEdit = true;
      }
      if (row.r01_NationalityID == -1) {
        this.isNationalityEdit = true;
        this.isEdit = true;
      }
      if (row.genderID == -1) {
        this.isGenderEdit = true;
        this.isEdit = true;
      }
      if (row.b16_DesigID == -1) {
        this.isDesigEdit = true;
        this.isEdit = true;
      }
      if (row.b19_ArrTravelModeID == -1) {
        this.isArrModeEdit = true;
        this.isEdit = true;
      }
      if (row.b19_DepTravelModeID == -1) {
        this.isDepModeEdit = true;
        this.isEdit = true;
      }
    },
    downloadSample() {
      nomineeDetailsJS.GetSampleExcel().then(
        (response) => {
          if (response.data.isSuccess) {
            var fileURL = response.data.result;
            let link = document.createElement("a");
            link.id = "mylink";
            link.href = fileURL;
            link.setAttribute(
              "download",
              "Import_Programme_Office_Participants.xls"
            );
            link.click();
          }
        },
        (error) => {},
        (failure) => {}
      );
    },
    GetDesigList() {
      const _data_ = { DesigID: -1, Type: 1 };
      allMasterJS.GetDesigList(_data_).then(
        (response) => {
          if (response.data.length > 0) {
            this.desig_List = response.data;
            // console.log(this.desig_List);
          }
        },
        (error) => {}
      );
    },
    clearImportExcel() {
      this.titleID = 1;
      this.desigID = -1;
      this.countryID = -1;
      this.genderID = -1;
      this.arrivalModeID = -1;
      this.departureModeID = -1;
      this.isTitleEdit = false;
      this.isDesigEdit = false;
      this.isNationalityEdit = false;
      this.isGenderEdit = false;
      this.isArrModeEdit = false;
      this.isDepModeEdit = false;
      this.ExcelData = [];
      this.isUpload = false;
    },
    uploadExcel1() {
      // console.log(jsonFile);
    },
    updateExcel() {
      var index = this.editindex;
      var row = this.editRow;
      if (this.titleID == -1 && this.isTitleEdit) {
        MessageBox.show({
          message: "Please Select Title",
          type: "error",
          title: "Error",
        });
        return;
      }
      if (this.desigID == -1 && this.isDesigEdit) {
        MessageBox.show({
          message: "Please Select Designation",
          type: "error",
          title: "Error",
        });
        return;
      }
      if (row.titleID == -1) {
        this.editRow.title = this.TitleList.filter((item) => {
          return item.titleID == this.titleID;
        })[0].titleName;
        this.editRow.titleID = this.TitleList.filter((item) => {
          return item.titleID == this.titleID;
        })[0].titleID;
      }
      if (row.r01_NationalityID == -1) {
        if (this.countryID != -1) {
          this.editRow.nationality = this.country_lst.filter((item) => {
            return item.countryID == this.countryID;
          })[0].countryName;
          this.editRow.r01_NationalityID = this.country_lst.filter((item) => {
            return item.countryID == this.countryID;
          })[0].countryID;
        } else {
          this.editRow.nationality = "";
          this.editRow.r01_NationalityID = -1;
        }
      }
      if (row.r07_GenderID == -1) {
        if (this.genderID != -1) {
          this.editRow.r07_GenderID = genderID;
          if (genderID == 1) this.ExcelData[index].gender = "Male";
          else this.editRow.gender = "Female";
        } else {
          this.editRow.gender = "";
          this.editRow.r07_GenderID = -1;
        }
      }
      if (row.b16_DesigID == -1) {
        this.editRow.designation = this.desig_List.filter((item) => {
          return item.desigID == this.desigID;
        })[0].desigName;
        this.editRow.b16_DesigID = this.desig_List.filter((item) => {
          return item.desigID == this.desigID;
        })[0].desigID;
      }
      if (row.b19_ArrTravelModeID == -1) {
        if (this.arrivalModeID != -1) {
          this.editRow.arrTravleMode = this.travelMode_List.filter((item) => {
            return item.travelModeID == this.arrivalModeID;
          })[0].travelModeValue;
          this.editRow.b19_ArrTravelModeID = this.travelMode_List.filter(
            (item) => {
              return item.travelModeID == this.arrivalModeID;
            }
          )[0].travelModeID;
        } else {
          this.editRow.arrTravleMode = "";
          this.editRow.b19_ArrTravelModeID = -1;
        }
      }
      if (row.b19_DepTravelModeID == -1) {
        if (this.departureModeID != -1) {
          this.editRow.depTravelMode = this.travelMode_List.filter((item) => {
            return item.travelModeID == this.departureModeID;
          })[0].travelModeValue;
          this.editRow.b19_DepTravelModeID = this.travelMode_List.filter(
            (item) => {
              return item.travelModeID == this.departureModeID;
            }
          )[0].travelModeID;
        } else {
          this.editRow.depTravelMode = "";
          this.editRow.b19_DepTravelModeID = -1;
        }
      }
      vue.nextTick(() => {
        this.editRow.updateStatusID = 1;
        this.editRow.updateStatus = "Updated";
      });
    },
    GetExcelData(event) {
      var file = event.target.files ? event.target.files[0] : null;
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const bstr = new Uint8Array(e.target.result);
          const wb = XLSX.read(bstr, { type: "array" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
          this.uploadExcel(data, file.name);
        };
        reader.readAsArrayBuffer(file);
      }
    },
    updateNomineeData() {
      const _data_ = {
        FileData: this.ExcelData,
        NomineeID: this.NomAuthID,
        ProgID: this.ProgID,
        FileTypeID: -1,
        FileID: -1,
        FileName: "Import_Programme_Office_Participants.xls",
        IsThroughERP: 0,
        Type: 1,
      };
      nomineeDetailsJS.ImportUpdatedPOCandidatesFromExcel(_data_).then(
        (response) => {
          // console.log(response.data);
          if (response.data.length > 0) {
            if (response.data[0].candidateID != -1) {
              this.ExcelData = response.data;
              this.$emit("AddORUpdateNomAuth", this.ProgID);
            } else {
              MessageBox.show({
                message: response.data[0].msg,
                type: "error",
                title: "Error",
              });
              event.target.value = null;
              this.isUpload = false;
            }
          }
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
            event.target.value = null;
            this.isUpload = false;
          } else {
            alert("Error: " + error.response.statusText);
            event.target.value = null;
            this.isUpload = false;
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
          event.target.value = null;
          this.isUpload = false;
        }
      );
    },
    uploadExcel(data, fileName, type) {
      this.GetDesigList();
      // console.log(data);
      const _data_ = {
        File: data,
        NomineeID: this.NomAuthID,
        ProgID: this.ProgID,
        FileTypeID: -1,
        FileID: -1,
        FileName: fileName,
        IsThroughERP: 0,
        Type: 1,
      };
      nomineeDetailsJS.ImportPOCandidatesFromExcel(_data_).then(
        (response) => {
          // console.log(response.data);
          if (response.data.length > 0) {
            if (response.data[0].candidateID != -1) {
              this.ExcelData = response.data;
              this.$emit("AddORUpdateNomAuth", this.ProgID);
            } else {
              MessageBox.show({
                message: response.data[0].msg,
                type: "error",
                title: "Error",
              });
              event.target.value = null;
              this.isUpload = false;
            }
          }
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
            event.target.value = null;
            this.isUpload = false;
          } else {
            alert("Error: " + error.response.statusText);
            event.target.value = null;
            this.isUpload = false;
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
          event.target.value = null;
          this.isUpload = false;
        }
      );
    },
    showExcelDiv(type) {
      if (this.NomAuthID != "") {
        if (type == 1) {
          this.entryTypeID = 1;
          // nomineeDetailsJS.GetJsonFormatForExcel().then(
          //   (response) => {
          //     if (response.data.isSuccess) {
          //       var list = response.data.result;
          //       let _obj = "{";
          //       list.forEach((element) => {
          //         _obj += '"' + element.value + '":"' + element.lable + '",';
          //       });
          //       _obj = _obj.substring(0, _obj.length - 1);
          //       _obj = _obj + "}";
          //       let object = JSON.parse(_obj);
          //       this.json_fields = object;
          //     }
          //   },
          //   (error) => {},
          //   (failure) => {}
          // );
        } else {
          this.entryTypeID = 0;
        }
      }
      this.generateCaptcha1(2, 110, 21);
    },
    addEditMaster(type) {
      if (type == 1) {
        this.masterAccountID = -1;
        this.btnSave = "Save As Master";
        this.btnSaveMsg = "Click Here to Save As Master";
      } else {
        this.btnSave = "Update As Master";
        this.btnSaveMsg = "Click Here to Update As Master";
      }
    },
    getCountry() {
      allMasterJS.getCountry().then(
        (result) => {
          if (result.data.length > 0) {
            this.country_lst = result.data;
            this.getAttType();
            if (this.userTypeID == 2) {
              this.GetMemberType();
            }
            //console.log(this.country_lst);
          }
        },
        (error) => {},
        (failure) => {}
      );
    },
    getTitle() {
      allMasterJS.getTitle().then(
        (result) => {
          if (result.data.length > 0) {
            this.title_List = result.data;
          }
        },
        (error) => {},
        (failure) => {}
      );
    },
    GetMemberType(ele) {
      this.memberType_list = [];
      let _data = {
        IsIndividualOnline: this.attTypeID,
        CountryID: this.countryID,
      };
      //alert(this.attTypeID + " : " + this.countryID);
      nomineeDetailsJS.GetMemberType(_data).then((response) => {
        if (response.data) {
          this.memberType_list = response.data;
          this.isForEdit = 1;
          //console.log(response.data);
          this.memberTypeID =
            this.memberType_list.length > 0
              ? this.memberType_list[0].memberTypeID
              : -1;

          //this.GetNominee();
        }
      });
    },
    getAttType() {
      // console.log(this.ModeOfExecution);
      if (this.ModeOfExecution == 1) {
        this.attTypeID = 0;
      } else if (this.ModeOfExecution == 2) {
        this.attTypeID = 1;
      }
    },
    GetMemebrBank() {
      let _data = { MemberTypeID: this.memberTypeID };
      nomineeDetailsJS.GetMemebrBank(_data).then((response) => {
        if (response.data) {
          this.bankID = response.data[0].bankID;
        }
      });
    },
    GetFoodPreference() {
      nomineeDetailsJS.GetFoodPreference().then(
        (response) => {
          // console.log(response.data);
          this.foodPreferencelst = response.data;
          this.GetMasterAccountList();
        },
        (error) => {},
        (failure) => {}
      );
    },
    GetMasterAccountList() {
      const _data_ = {
        loginID: this.NomAuthID,
        masterAccountID: -1,
        UserTypeID: this.userTypeID,
      };
      nomineeDetailsJS.GetMasterAccountList(_data_).then(
        (response) => {
          if (response.data) {
            this.masterAccount_List = response.data;
            this.generateCaptcha1(2, 110, 21);
            this.getCountry();
            if (this.userTypeID == 2 || this.userTypeID == 3) {
              //this.editNomineeMaster(response.data[0]);
              //console.log(response.data);
            }
          }
        },
        (error) => {}
      );
    },
    SaveNominee() {
      //debugger;
      //alert(this.userTypeID + " : " + this.bankID);
      if (this.NomineeID == -1) {
        MessageBox.show({
          message: "Nominating Auth is not Find",
          type: "error",
          title: "Error",
        });
        return;
      }
      if (this.NomAuthID == -1 && (this.userTypeID == 1 || this.userTypeID == 4)) {
        MessageBox.show({
          message: "Nominating Auth is not Selected",
          type: "error",
          title: "Error",
        });
        return;
      }
      if (this.captchaValue1 == "") {
        MessageBox.show({
          message: "Please Enter Captcha",
          type: "error",
          title: "Error",
        });
        return;
      }
      let msg = "";
      if (this.attTypeID == -1) {
        msg = "Please Select Attendance Type";
      }
      if (this.fName == "") {
        msg = "Please Enter First Name";
      }
      if (this.countryID == -1) {
        msg += "<br /> Please Select Country";
      }
      if (this.nominationDate.convertToString("dd MMM yyyy") == "01 Jan 1900") {
        msg += "<br /> Please Select Nomination Date";
      }
      if (this.email1 == "") {
        msg += "<br /> Please Enter Email-ID";
      }
      if (this.email1 != "") {
        let E = this.CheckEmailOrMob(this.email1);
        if (E != "E") {
          msg += "<br /> Please Enter Valid Email ID ";
        }
      }
      if (this.curAddress == "") {
        msg += "<br /> Please Enter Current Address";
      }
      // if (this.userTypeID == 2 && this.bankID == -1) {
      //   msg += "<br /> Please Select Member Type";
      // }
      if (this.email2 != "") {
        let EE = this.CheckEmailOrMob(this.email2);
        if (EE != "E") {
          msg += "<br /> Please Enter Valid Email ID (SEC)";
        }
      }
      if (this.mobileNo == "") {
        msg += "<br /> Please Enter Mobile No. [C.C./Mobile No.] ";
      }
      if (this.mobileNo != "") {
        let M = this.CheckEmailOrMob(this.mobileNo);
        if (M != "M") {
          msg += "<br /> Please Enter Mobile No. [C.C./Mobile No.] ";
        }
      }
      if (this.userTypeID == 2 && this.organizationName == "") {
        msg += "<br /> Please Enter Organization Name ";
      }
      if (this.desigID == -1) {
        msg += "<br /> Please Enter Designation ";
      }
      if (msg != "") {
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Error",
        });
        return;
      }
      if (
        this.btnSave == "Save As Master" ||
        this.btnSave == "Update As Master"
      ) {
        this.showMessageBox4();
      } else if (this.btnSave == "Save" || this.btnSave == "Update") {
        // console.log(this.masterAccountID);
        if (this.masterAccountID == -1) {
          if (this.userTypeID == 1 || this.userTypeID==4) {
            this.showMessageBox3();
          } else {
            this.SaveNomineeDetails(false);
          }
        } else {
          this.showMessageBox5();
        }
      }
      if (this.masterAccountID != -1) {
        this.masterAccount_List.forEach((element) => {
          if (this.masterAccountID == element.masterAccountID)
            this.candidateLoginID = element.candidateLoginID;
        });
      }
      // alert(this.candidateLoginID);
    },
    SaveNomineeDetails(saveInMasterAlso) {
      //debugger;
      let _SaveData = {
        ProgID: this.ProgID,
        CandidateID: this.candidateID,
        NomineeID: this.NomAuthID,
        CandidateLoginID: this.userTypeID == 4 && this.candidateID == -1 ? -1 : this.candidateLoginID,
        CandGRNo: this.candGRNo,
        TitleID: this.titleID,
        FirstName: this.fName,
        MiddleName: this.mName,
        SurName: this.lName,
        DOB: this.dob.convertToString("dd MMM yyyy"),
        NationalityID: this.countryID,
        GenderID: this.genderID,
        AreaID: this.areaID,
        CurPhoneCC: this.contactCC,
        CurPhoneAC: this.contactAC,
        ContactNo: this.contactNo,
        PerPhoneCC: this.altContactCC,
        PerPhoneAC: this.altContactAC,
        PerPhone: this.altContactNo,
        CurMobileCC: this.mobileCC,
        CurMobile: this.mobileNo,
        PerMobileCC: this.altMobileCC,
        PerMobile: this.altMobileNo,
        Email: this.email1,
        SecondEmail: this.email2,
        Address1: this.curAddress,
        Address2: this.perAddress,
        BankID: this.bankID,
        OrganizationName: this.organizationName,
        DesigID: this.desigID,
        Scale: this.scale,
        EmployeeNo: this.empNo,
        AriivalDate: this.arrivalDate.convertToString("dd MMM yyyy"),
        ArrivalTime: "01 Jan 1900 " + this.arrivalTime.convertToString("HH:MM:ss"),
        ArrTravelModeID: this.arrivalModeID,
        ArrivalDetails: this.arrivalDetails,
        DepatureDate: this.departureDate.convertToString("dd MMM yyyy"),
        DepatureTime: "01 Jan 1900 " + this.departureTime.convertToString("HH:MM:ss"),
        DepTravelModeID: this.departureModeID,
        DepartureDetails: this.departureDetails,
        IsCancel: this.isCancel,
        IsPickUpRequired: this.isPickUpRequired,
        RoomID: this.roomID,
        NominationCode: this.NominationCode,
        Remark: this.remarkData,
        FaxCC: this.faxCC,
        FaxAC: this.faxAC,
        Fax: this.faxNo,
        GSTNo: this.gstNO,
        PFNo: this.pFNo,
        candidateMasterAccountID: this.masterAccountID,
        SaveInMasterAlso: saveInMasterAlso,
        PaymentMode: this.paymentMode,
        UserTypeID: this.userTypeID,
        NominationDate: this.nominationDate.convertToString("dd MMM yyyy"),
        AcceptanceDate: this.dateOfAcceptance.convertToString("dd MMM yyyy"),
        IsCandidateOnline: this.attTypeID,
        CaptchaValue: this.captchaValue1,
        CaptchaKey: this.captchaKey1,
        FoodPreferences: this.FoodPrefID,
        CurrentStateID: -1,
        PermanentStateID: -1,
      };
      nomineeDetailsJS.SaveNominee(_SaveData).then(
        (response) => {
          if (response.data) {
            //console.log(response.data);
            if (response.data[0].isSuccess == true) {
              MessageBox.show({
                message: response.data[0].msg,
                type: "success",
                title: "Success",
              });
              this.$emit("AddORUpdateNomAuth", this.ProgID);
              if (this.userTypeID == 1) {
                this.RESETNOMINEE();
              } else {
                this.GetNominee();
              }
            } else {
              MessageBox.show({
                message: response.data[0].msg,
                type: "error",
                title: "Error",
              });
            }
          }
          this.captchaValue1 = "";
          this.captchaKey1 = "";
          this.generateCaptcha1(2, 110, 21);
        },
        (error) => {}
      );
    },
    GetNominee() {
      let Type = 1;
      // console.log(this.CandidateData);
      if (this.userTypeID == 1 || this.userTypeID == 2) {
        Type = 1;
      } else {
        Type = 2;
      }
      if (this.CandidateData != null && this.userTypeID == 1) {
        this.editNominee(this.CandidateData[0]);
      } else {
        //if (this.userTypeID == 1 || this.userTypeID == "1") {
        let _param = {
          NomineeID: this.NomAuthID,
          CandidateID: this.candidateID,
          UserTypeID: this.userTypeID,
          Type: Type,
        };
        nomineeDetailsJS.GetNominee(_param).then((response) => {
          if (response.data) {
            //console.log(response.data[0]);
            this.lst_CandidateNominate = response.data;
            if (
              response.data.length > 0 &&
              (this.userTypeID == 2 || this.userTypeID == 3)
            )
              this.editNominee(response.data[0]);
          }
        });
      }
      //}
    },
    GetNomineeMaster() {
      let _param = {
        LoginID: this.userLoginID,
        NomineeID: this.nomineeID,
        CandidateID: -1,
      };
      nomineeDetailsJS.GetNomineeMaster(_param).then((response) => {
        if (response.data) {
          this.lst_NomineeTemplate = response.data;
        }
      });
      //}
    },
    editNominee(i) {
      // if (i === undefined) {
      //   return;
      // } else {
      //console.log(i);
      if (i !== undefined || i != null) {
        this.refNo = i.candGRNo;
        this.checkBoxDisplay = false;
        // this.progID = i.progID;
        this.candidateID = i.candidateID;
        this.nomineeID = i.nomineeID;
        this.candidateLoginID = i.candidateLoginID;
        this.candGRNo = i.candGRNo;
        this.titleID = i.titleID;
        this.memberTypeID = i.memberTypeID;
        this.fName = i.firstName;
        this.mName = i.middleName;
        this.lName = i.surName;
        this.dob = new Date(i.dob);
        this.countryID = i.nationalityID;
        this.masterAccountID = i.b73_MasterAccountID;
        this.genderID = i.genderID;
        this.areaID = i.areaID;
        this.isDisableMobile = i.curMobile != "" ? true : false;
        this.isDisableEmail = true;
        this.altContactCC = i.perPhoneCC;
        this.altContactAC = i.perPhoneAC;
        this.altContactNo = i.perPhone;
        this.contactCC = i.curPhoneCC;
        this.contactAC = i.curPhoneAC;
        this.contactNo = i.contactNo;
        this.altMobileCC = i.perMobileCC;
        this.altMobileNo = i.perMobile;
        this.mobileCC = i.curMobileCC;
        this.mobileNo = i.curMobile;
        this.email1 = i.email;
        this.email2 = i.secondEmail;
        this.curAddress = i.address1;
        this.perAddress = i.address2;
        this.bankID = i.bankID;
        this.organizationName = i.organizationName;
        this.desigID = i.desigID;
        // if (i.desigName.trim() != "") {
        // $('input[type="search"]').val(i.desigName);
        vue.nextTick(() => {
          this.$root.$emit("callChange", i.desigName, i.desigID);
        });
        this.desigName = i.desigName;
        this.scale = i.scale;
        this.empNo = i.employeeNo;
        this.arrivalDate = new Date(i.ariivalDate);
        this.arrivalTime = new Date(i.arrivalTime);
        this.arrivalModeID = i.arrTravelModeID;
        this.arrivalDetails = i.arrivalDetails;
        this.departureDate = new Date(i.depatureDate);
        this.departureTime = new Date(i.depatureTime);
        this.departureModeID = i.depTravelModeID;
        this.departureDetails = i.departureDetails;
        this.isCancel = i.isCancel == true ? 1 : 0;
        this.isPickUpRequired = i.isPickUpRequired == true ? 1 : 0;
        this.roomID = i.roomID;
        this.nominationCode = i.nominationCode;
        this.remarkData = i.remark;
        this.faxCC = i.faxCC;
        this.faxAC = i.faxAC;
        this.faxNo = i.fax;
        this.gstNO = i.gSTNo == null ? "" : i.gSTNo;
        this.pFNo = i.pFNo == null ? "" : i.pFNo;
        this.candidateMasterAccountID = i.candidateMasterAccountID;
        this.paymentMode = i.paymentMode;
        this.FoodPrefID = i.foodPreferences == "" ? "-1" : i.foodPreferences;
        this.btnSave = "Update";
        // console.log(i.dateOfNomination);
        this.nominationDate =
          new Date(i.dateOfNomination).convertToString("dd MMM yyyy") ==
          "01 Jan 1900"
            ? new Date()
            : new Date(i.dateOfNomination);
        this.dateOfAcceptance = new Date(i.dateOfAcceptance);
        if (this.isForEdit == 0) {
          // this.attTypeID = i.isOnlineCandidate;
          if (i.isOnlineCandidate) this.attTypeID = 1;
          else this.attTypeID = 0;
        }
      }
    },
    editNomineeMaster(i) {
      if (i !== undefined || i != null) {
        this.checkBoxDisplay = false;
        // console.log(i);
        // this.progID = i.progID;
        this.nomineeID = i.nomineeID;
        this.candGRNo = i.candGRNo;
        this.titleID = i.rankID;
        this.fName = i.fName;
        this.mName = i.mName;
        this.lName = i.lName;
        this.dob = new Date(i.dob);
        this.genderID = i.genderID;
        this.areaID = i.areaID;
        this.altContactCC = i.alternateContactNoCC;
        this.altContactAC = i.alternateContactNoAC;
        this.altContactNo = i.alternateContactNo;
        if (this.masterAccountID == -1)
          this.masterAccountID = i.b73_MasterAccountID;
        this.contactCC = i.contactNoCC;
        this.contactAC = i.contactNoAC;
        this.contactNo = i.contactNo;
        this.altMobileCC = i.alternateMobileNoCC;
        this.altMobileNo = i.alternateMobileNo;
        this.mobileCC = i.userMobileCC;
        this.mobileNo = i.userMobile;
        this.email1 = i.userEMail;
        this.email2 = i.alternateEmail;
        this.curAddress = i.address1;
        this.perAddress = i.address2;
        this.bankID = i.bankID;
        this.organizationName = i.organizationName;
        this.desigID = i.desigID;
        vue.nextTick(() => {
          this.$root.$emit("callChange", i.desigName, i.desigID);
        });
        // this.desigName = i.desigName;
        this.scale = i.scale;
        this.empNo = i.employeeNo;
        this.nominationCode = i.nominationCode;
        this.remarkData = i.remark;
        this.nominationDate = new Date();
        this.dateOfAcceptance = new Date();
        this.faxCC = i.faxCC;
        this.faxAC = i.faxAC;
        this.faxNo = i.fax;
        this.gstNO = i.gstNo == null ? "" : i.pFNo;
        this.pFNo = i.pfNo == null ? "" : i.pFNo;
        this.curAddress = i.address1;
        this.perAddress = i.address2;
        this.countryID = i.nationalityID;
        // console.log(i.foodPreferences);
        this.FoodPrefID = i.foodPreferences == null ? -1 : i.foodPreferences;
      }
    },
    EDITRECORD() {
      //console.log(this.masterAccount_List);
      this.masterAccount_List.forEach((element) => {
        if (element.masterAccountID == this.masterAccountID) {
          this.editNomineeMaster(element);
        }
      });
    },
    ADDRECORD() {
      this.masterAccount_List.forEach((element) => {
        if (element.masterAccountID == this.masterAccountID) {
          this.btnSave = "Save";
          this.editNomineeMaster(element);
        }
      });
    },
    clear(e) {
      this.RESETNOMINEE(e);
    },
    RESETNOMINEE(e) {
      $('input[type="search"]').val("");
      this.areaID = -1;
      this.candGRNo = "";
      this.refNo = "";
      this.gstNO = " ";
      this.pFNo = "";
      this.attTypeID = 0;
      this.titleID = 1;
      this.fName = "";
      this.mName = "";
      this.lName = "";
      this.countryID = -1;
      this.countryName = "";
      this.contactCC = "+91";
      this.contactAC = "";
      this.contactNo = "";
      this.altContactCC = "+91";
      this.altContactAC = "";
      this.altContactNo = "";
      this.mobileCC = "+91";
      this.mobileNo = "";
      this.altMobileCC = "+91";
      this.altMobileNo = "";
      this.faxCC = "+91";
      this.faxAC = "";
      this.faxNo = "";
      this.bankID = -1;
      this.bankName = "";
      this.desigID = -1;
      this.desigName = "";
      this.empNo = "";
      this.email1 = "";
      this.email2 = "";
      this.dob = new Date();
      this.scale = "";
      this.nominationDate = new Date();
      this.roomID = -1;
      this.dateOfAcceptance = new Date();
      this.arrivalDate = new Date();
      this.arrivalTime = new Date();
      this.arrivalModeID = -1;
      this.arrivalDetails = "";
      this.departureDate = new Date();
      this.departureTime = new Date();
      this.departureModeID = -1;
      this.departureDetails = "";
      this.isPickUpRequired = 0;
      this.genderID = 1;
      this.isCancel = 2;
      this.curAddress = "";
      this.perAddress = "";
      this.remarkData = "";
      this.memberTypeID = -1;
      this.memberBankID = -1;
      // if (e == 1) {
      //   this.$emit("IsClear", true);
      //   //   this.nomineeID = -1;
      //   //   this.nominationCode = "";
      // }
      this.email = "";
      this.travelModeID = -1;
      this.candidateID = -1;
      this.isIndividualNominee = -1;
      this.isOnlineCandidate = -1;
      this.isApproved = -1;
      this.isSyncedInERP = -1;
      this.entryDate = new Date();
      this.organizationName = "";
      this.candidateMasterAccountID = -1;
      this.saveInMasterAlso = false;
      this.paymentMode = -1;
      this.candidateLoginID = -1;
      this.userLoginID = -1;
      if (this.userTypeID == 1) this.checkBoxDisplay = true;
      else this.checkBoxDisplay = false;
      this.masterAccountID = -1;
      this.memberTypeID = -1;
      this.attTypeID = -1;
      this.isForEdit = 0;
      this.isSaveinMasterAsNew = false;
      this.desigName = "";
      this.getCountry();
      this.getTitle();
      //this.GetBank();
      //this.GetMemberType();
      if (this.userTypeID == 1) {
        if (this.CandidateData.length > 0) {
          this.CandidateData = [];
        }
        this.candData = [];
        this.candidateID = -1;
        this.isDisableEmail = false;
        this.isDisableMobile = false;
      }
      this.GetNominee();
      this.GetFoodPreference();
      this.FoodPrefID = "-1";
      this.btnSave = "Save";
    },
    CheckEmailOrMob(value) {
      if (this.mobileCC == "+91") {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(value)) {
          return "E";
        } else if (/^[3456789]\d{9}$/.test(value) && value.length == 10) {
          return "M";
        }
      } else {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(value)) {
          return "E";
        } else if (value.length < 21) {
          return "M";
        }
      }
    },
    yesClick() {
      this.SaveNomineeDetails(true);
    },
    noClick() {
      this.SaveNomineeDetails(false);
    },
    paymentOption() {
      this.$emit("ChangeNomAuthIDForPayment", this.NomAuthID);
    },
    paidOption() {
      this.$emit("ChangeNomAuthDetails", this.CandidateData[0]);
    },
    showMessageBoxPaymentOption() {
      MessageBox.show(
        {
          message: "Are you sure to Pay?",
          type: "confirm",
          title: "",
          defaultButton: 2,
        },
        {
          buttonName: "Yes",
          buttonAction: this.paymentOption,
        },
        { buttonName: "No", buttonAction: this.clear }
      );
    },
    showMessageBox4(e) {
      MessageBox.show(
        {
          message: "Are you sure to save?",
          type: "confirm",
          title: "",
          defaultButton: 2,
        },
        {
          buttonName: "Yes",
          buttonAction: this.SaveMasterData,
        },
        { buttonName: "No", buttonAction: this.showFlashMessage }
      );
    },
    showMessageBox5(e) {
      MessageBox.show(
        {
          message: "Are you sure to save?",
          type: "confirm",
          title: "",
          defaultButton: 3,
        },
        {
          buttonName: "Yes",
          buttonAction: this.noClick,
        },
        {
          buttonName: "No",
          buttonAction: this.showFlashMessage,
        }
      );
    },
    showMessageBox3(e) {
      MessageBox.show(
        {
          message: "Do you want to Save as Master also?",
          type: "confirm",
          title: "",
          defaultButton: 3,
        },
        {
          buttonName: "Yes",
          buttonAction: this.yesClick,
        },
        {
          buttonName: "No",
          buttonAction: this.noClick,
        },
        { buttonName: "Cancel", buttonAction: this.showFlashMessage }
      );
    },
    SaveMasterData() {
      let msg = "";
      if (this.email1 != "") {
        let E = this.CheckEmailOrMob(this.email1);
        if (E != "E") {
          msg += "<br /> Please Enter Valid Email ID ";
        }
      }
      if (this.email2 != "") {
        let EE = this.CheckEmailOrMob(this.email2);
        if (EE != "E") {
          msg += "<br /> Please Enter Valid Email ID (SEC)";
        }
      }
      if (msg != "") {
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Error",
        });
        return;
      }
      let _SaveData = {
        //this.masterAccountID
        MasterAccountID: this.masterAccountID,
        UserMobileCC: this.mobileCC,
        UserMobile: this.mobileNo,
        UserEMail: this.email1,
        RankID: this.titleID,
        FName: this.fName,
        MName: this.mName,
        LName: this.lName,
        GenderID: this.genderID,
        DOB: this.dob,
        NationalityID: this.countryID,
        BankID: this.bankID,
        DesigID: this.desigID,
        Scale: this.scale,
        EmployeeNo: this.empNo,
        Address1: this.curAddress,
        Address2: this.perAddress,
        AlternateMobileNoCC: this.altMobileCC,
        AlternateMobileNo: this.altMobileNo,
        AlternateEmail: this.email2,
        ContactNoCC: this.contactCC,
        ContactNoAC: this.contactAC,
        ContactNo: this.contactNo,
        AlternateContactNoCC: this.altContactCC,
        AlternateContactNoAC: this.altContactAC,
        AlternateContactNo: this.altContactNo,
        FaxCC: this.faxCC,
        FaxAC: this.faxAC,
        Fax: this.faxNo,
        CaptchaValue: this.captchaValue1,
        CaptchaKey: this.captchaKey1,
      };
      // console.log(_SaveData);
      nomineeDetailsJS.SaveMasterData(_SaveData).then(
        (response) => {
          if (response.data) {
            //console.log(response.data);
            if (response.data[0].isSuccess == true) {
              MessageBox.show({
                message: response.data[0].msg,
                type: "success",
                title: "Success",
              });
              this.RESETNOMINEE();
            } else {
              MessageBox.show({
                message: response.data[0].msg,
                type: "error",
                title: "Error",
              });
            }
          }
          this.captchaValue1 = "";
          this.captchaKey1 = "";
          this.generateCaptcha1(2, 110, 21);
        },
        (error) => {}
      );
    },
    generateCaptcha1(type, w, h) {
      this.captchaValue1 = "";
      const _data_ = { width: w, height: h };
      LoginJS.GenerateCaptcha(_data_).then(
        (response) => {
          if (type == 2) {
            $("#imgCaptcha1").attr("src", response.data.result1);
            this.captchaKey1 = response.data.result;
          }
        },
        (error) => {
          if (error.response.data.message != undefined) {
            alert(
              error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage
            );
          } else {
            alert("Error: " + error.response.data);
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
        }
      );
    },
    RetryPayment(nomineeID) {
      const _data = {
        NomineeID: nomineeID,
        Type: 1,
      };
      PaymentJS.GetListFailedTransactions(_data).then(
        (response) => {
          console.log(response.data);
          if (response.data[0].isSuccess) {
            MessageBox.show({
              message: response.data[0].msg,
              type: "success",
              title: "Success",
            });
            this.$emit("AddORUpdateNomAuth", this.ProgID);
            if (this.userTypeID == 1) {
              this.RESETNOMINEE();
            } else {
              this.GetNominee();
            }
          } else {
            MessageBox.show({
              message: response.data[0].msg,
              type: "error",
              title: "Error",
            });
          }
          this.captchaValue1 = "";
          this.captchaKey1 = "";
          this.generateCaptcha1(2, 110, 21);
        },
        (error) => {},
        (failure) => {}
      );
    },
  },
  computed: {},
  watch: {
    NomAuthID(newValue, oldValue) {
      if (this.userTypeID == 2 || this.userTypeID == 3) this.GetNominee();
    },
    candData(newValue, oldValue) {
      if (this.userTypeID == 1) {
        this.GetNominee();
      } else {
        this.editNominee(this.candData[0]);
      }
    },
    attTypeID(newValue, oldValue) {
      if (this.userTypeID == 2) {
        this.GetMemberType(0);
      }
    },
    countryID(newValue, oldValue) {
      if (this.userTypeID == 2) {
        this.GetMemberType(0);
      }
    },
    memberTypeID(newValue, oldValue) {
      if (this.userTypeID == 2) {
        this.GetMemebrBank();
      }
    },
    entryTypeID(newValue, oldValue) {
      if (this.entryTypeID == 0) this.generateCaptcha1(2, 110, 21);
    },
  },
  mounted() {
    this.candData = this.CandidateData;
    this.GetFoodPreference();
  },
};
</script>
<style scoped>
.radioSpan {
  margin-right: 10px;
  border: solid thin;
  border-radius: 5px;
  line-height: 25px;
  padding: 0px 7px;
  cursor: pointer;
}
.radioSpanChecked {
  background-color: white;
}
.radioSpan > label {
  cursor: pointer;
}
.instruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 10px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: small;
  margin-bottom: 6px;
  border-bottom: solid thin darkgrey;
}
.payinstruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 20px;
  line-height: 20px;
  font-size: inherit;
  margin-bottom: 6px;
  /* border-bottom: solid thin darkgrey; */
}
.GridFlex {
  width: 50%;
  overflow-wrap: anywhere;
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  box-shadow: 3px 1px 4px;
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  box-shadow: 3px 1px 4px black;
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.docfileImg {
  height: 50px;
  width: 50px;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  width: 450px;
  border: solid 1px;
  border-radius: 4px;
  top: 200px;
  position: absolute;
  min-height: 256px;
  right: 450px;
  background-color: rgba(255, 248, 248, 0.86); /*rgb(223, 223, 223);*/
  box-shadow: 1px 1px 20px 1px White;
  border-radius: 18px 18px 18px 18px;
  z-index: 2;
  color: black !important;
}
.PopUpDetail {
  padding: 3px;
  min-height: 200px;
  max-height: 400px;
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 30px;
  border-bottom: solid 1px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.drop_area {
  height: 60px;
  background-color: antiquewhite;
  margin: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  line-height: 60px;
}
.file_drop {
  font-size: small;
}
.preview_content {
  background-color: lightblue;
  border-radius: 3px;
  margin: 3px;
  min-height: 177px;
  width: 99%;
  overflow: auto;
  padding: 8px;
  border-radius: 1px 1px 20px 20px;
}
.file_column {
  align-content: center;
  text-align: center;
  float: left;
  width: 25%;
  position: relative;
  /* border: solid thin;
                border-radius: 8px; */
  margin-left: 10px;
}
.file_row:after {
  content: "";
  display: table;
  clear: both;
}
.del_img {
  border-radius: 15px;
  cursor: pointer;
  padding: 5px 5px 5px 5px;
  background-color: rgb(255, 0, 0);
  color: White;
  font-weight: bold;
  position: absolute;
  right: -12px;
  z-index: 5001;
}
.del_img:hover {
  background-color: #fb0bbf;
}
.preview_div {
  align-content: center;
  text-align: center;
  height: 100px;
  width: 110px;
  margin: 2px;
  cursor: pointer;
  border: solid thin darkgray;
  border-radius: 10px;
  background-color: rgba(133, 236, 236, 0.15);
}
.percent_div {
  color: #f3dbdb;
  font-weight: bold;
  align-content: center;
  text-align: center;
  width: 100%;
}
.file_preview {
  height: 80px;
  width: 80px;
}
.file_name {
  font-size: 11px;
  text-overflow: ellipsis;
  width: calc(80%);
  display: inline-block;
  /* color: #f3dbdb; */
}
.file_count {
  margin-top: 5px;
  margin-left: 5px;
  vertical-align: middle;
  padding: 0px 3px 3px 3px;
  font-size: small;
  font-weight: bold;
  font-family: Tahoma;
  background-color: rgba(255, 255, 255, 0.41);
  color: Black;
  border: 1px dashed #ccc;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.error_upload {
  background-color: red;
}
.profileDiv {
  height: 170px;
  width: 180px;
}
.signatureDiv {
  height: 170px;
  width: 300px;
}
.profileImg {
  height: 100%;
  width: 100%;
  border-radius: 10px;
  box-shadow: 5px -4px 5px #807878;
  border-left: solid thin;
  border-bottom: solid thin;
}
.AppHeader {
  border: solid thin gainsboro;
  border-radius: 5px;
  min-height: 55px;
  font-size: medium;
  font-weight: bold;
}
.paymentLabels {
  color: black;
  font-weight: bold;
  font-size: medium;
  text-align: left;
}
.paymentLabels > .Flex_Row {
  border-bottom: solid thin ghostwhite;
}
fieldset {
  margin-bottom: 4px !important;
}
.childSaveTable {
  width: 98%;
  margin-left: 10px;
}
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.Green {
  background-color: greenyellow;
  display: block;
  font-weight: 600;
}
.appNoClass {
  display: inline-block;
  border: solid thin;
  padding: 5px 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  /* font-family: verdana; 
                box-shadow: 1px 1px 4px 2px darkgrey;*/
  margin: 0px !important;
  width: 95%;
}
.appNoClass:hover {
  background-color: darkorange;
}
.hidenShowClass {
  display: inline-block;
  border: solid thin;
  padding: 2px 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  /* font-family: verdana; */
  -webkit-box-shadow: 1px 1px 4px 2px darkgrey;
  box-shadow: 1px 1px 4px 2px darkgrey;
  right: 34px;
  position: absolute;
}
.hidenShowClass:hover {
  background-color: darkorange;
}
.myIconButton {
  padding: 0px;
}
.myIconButton a.glyphicons:before {
  font-size: 21px;
  cursor: pointer;
}
.Multibutton {
  padding: 0px;
}
.Multibutton a.glyphicons:before {
  font-size: 18px;
  cursor: pointer;
  margin-top: -2px;
  display: block;
}
.blackColor {
  color: black;
}
.redColor {
  color: red;
}
.DropDownHeigh {
  height: 27px;
  line-height: 22px;
}
.RowHeight {
  min-height: 29px;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divNominatingAuth {
  margin-left: 4px;
  margin-right: 5px;
  border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 0px 5px;
}
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(200px);
  opacity: 0;
}
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
.tblEntryForm > .Flex_Row {
  display: flex;
  flex-wrap: wrap;
}
/* .tblEntryForm > .Flex_Row > .Flex_Cell {
            width: 25% !important;
        } */

@media screen and (max-width: 800px) {
  .GridFlex {
    width: 100%;
    overflow-wrap: anywhere;
  }
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .GridFlex {
    width: 100%;
    overflow-wrap: anywhere;
  }
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
.myrow {
}
.myrow:hover {
  background-color: antiquewhite;
  border-radius: 10px;
  transition: all 0.6s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/NomineeDetails.vue